var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 6.5H17.4C18.5598 6.5 19.5 7.4402 19.5 8.6V9.5L4.5 9.5V8.6C4.5 7.4402 5.4402 6.5 6.6 6.5ZM3 11V9.5V8.6C3 6.61178 4.61177 5 6.6 5H17.4C19.3882 5 21 6.61177 21 8.6V9.5V11V15.4C21 17.3882 19.3882 19 17.4 19H6.6C4.61178 19 3 17.3882 3 15.4V11ZM19.5 11V15.4C19.5 16.5598 18.5598 17.5 17.4 17.5H6.6C5.4402 17.5 4.5 16.5598 4.5 15.4V11L19.5 11Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })));
};
export default SvgCard;